// extracted by mini-css-extract-plugin
export var grid = "navigation-dropdown-module--grid--50635";
export var gridWithRowGap = "navigation-dropdown-module--grid--with-row-gap--915dd";
export var maxWidthContainer = "navigation-dropdown-module--max-width-container--6aadf";
export var mt0 = "navigation-dropdown-module--mt-0--87373";
export var mt1 = "navigation-dropdown-module--mt-1--69f63";
export var mt2 = "navigation-dropdown-module--mt-2--1cf37";
export var mt3 = "navigation-dropdown-module--mt-3--e4aea";
export var mt4 = "navigation-dropdown-module--mt-4--9caa0";
export var mt5 = "navigation-dropdown-module--mt-5--c727c";
export var mt6 = "navigation-dropdown-module--mt-6--1ad1c";
export var navigationDropdown = "navigation-dropdown-module--navigation-dropdown--d323e";
export var navigationDropdownExpanded = "navigation-dropdown-module--navigation-dropdown--expanded--f94aa";
export var navigationDropdown__btn = "navigation-dropdown-module--navigation-dropdown__btn--c08ac";
export var navigationDropdown__btnWrapper = "navigation-dropdown-module--navigation-dropdown__btn-wrapper--9744c";
export var navigationDropdown__items = "navigation-dropdown-module--navigation-dropdown__items--a7d52";
export var navigationDropdown__itemsCaret = "navigation-dropdown-module--navigation-dropdown__items-caret--486fb";
export var navigationDropdown__itemsWrapper = "navigation-dropdown-module--navigation-dropdown__items-wrapper--34f83";
export var navigationDropdown__leftIcon = "navigation-dropdown-module--navigation-dropdown__left-icon--1e585";
export var navigationDropdown__rightIcon = "navigation-dropdown-module--navigation-dropdown__right-icon--7096f";
export var removeVisuallyHidden = "navigation-dropdown-module--remove-visually-hidden--808ad";
export var visuallyHidden = "navigation-dropdown-module--visually-hidden--714e6";
export var widgetBase = "navigation-dropdown-module--widget-base--484a5";